// extracted by mini-css-extract-plugin
module.exports = {"TwitchChip":"TwitchChip_TwitchChip__30kqj","TwitchIcon":"TwitchChip_TwitchIcon__QqjgW"};